<div class="background-sign">
    <mat-toolbar color="primary" class="toolbar">
        <a mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
        </a>
        <mat-menu #menu="matMenu">
            <a mat-menu-item (click)="gotoQuote()">
                <mat-icon>feed</mat-icon>
                <span>Quote</span>
            </a>
            <a mat-menu-item (click)="gotoQuestionnaire()">
                <mat-icon>feed</mat-icon>
                <span>Questionnaire</span>
            </a>
            <a mat-menu-item (click)="gotoPay()">
                <mat-icon>credit_card</mat-icon>
                <span>Payment</span>
            </a>
        </mat-menu>
        <img src="../assets/img/mgis/MGIS2.png" alt="MGIS Logo" class="logo" />
        <div class="toolbar-inner-sign">High Limits Disability Insurance Application</div>
    </mat-toolbar>
    <div class="app-progress">
        <div class=app-progress-inner>Application Progress</div>
        <ngb-progressbar class="mb-3 progress-bar" [showValue]="true" type="primary" [value]="percent" />
    </div>
    <div class="main">
        <br />
        <h3 class="main-inner-title">Application Submission</h3>
        <div class="checkboxes">
            <h3 class="main-inner">Please check each statement below</h3>
            <mat-checkbox [(ngModel)]="statement1" class="statement statement-sign">I certify, to the best of my knowledge and belief,
                that:</mat-checkbox>
            <ul class="sign-detail">
                <li>The information I have provided in the Application is true,
                    accurate and complete.</li>
                <li>I have read, or had read to me, the completed Application,
                    and understand that any false statements or
                    misrepresentations made in it may result in a loss of coverage
                    under the Insurance Policy.</li>
            </ul>
        </div>
        <div class="checkboxes">
            <mat-checkbox [(ngModel)]="statement2" class="statement statement-sign">I confirm my understanding that:</mat-checkbox>
            <ul class="sign-detail">
                <li>Should a policy be issued to me, I agree to receive all
                    mailings, invoices, and communications electronically. Such
                    electronic mailings may even include cancellation or
                    non-renewal notices.</li>
                <li>My Application may be denied and I may be refused
                    insurance if MGIS determines that I am not insurable. If MGIS
                    determines that I am not insurable, it will explain in writing the
                    basis of its determination.
                </li>
                <li>
                    If coverage is approved and a claim is submitted, current and
                    historical medical and financial data will be collected at that
                    time to verify that the answers and information I have provided
                    on this form are correct.
                </li>
            </ul>

        </div>
        
        @for( document of documents; track documents; let i = $index) {
        <div class="checkboxes">
            <mat-checkbox [(ngModel)]="linksChecked[i]" class="statement statement-sign">I acknowledge receipt of the <a href="{{document.URI}}">{{document.Type}}</a> regarding surplus lines insurance. My signature on this application is also my
                signature of this form.</mat-checkbox>
        </div>
        }

        <div class="checkboxes">
            <mat-checkbox [(ngModel)]="statement3" class="statement statement-sign checkbox-align">I authorize an initial payment of <strong>${{ total | number }}</strong> to be
                withdrawn by MGIS from my bank account as previously outlined. Withdrawal will only occur if my
                application is approved and bound.</mat-checkbox>
        </div>

    </div>

    <div>
    <div class="mt-1 mb-3">
        <button mat-flat-button class="button-mgis" (click)="gotoPay()">Back</button>
        <button mat-flat-button class="button-mgis" (click)="signAndSubmit()">Sign and Submit</button>
    </div>
</div>